import { render } from "./EBEquipment.vue?vue&type=template&id=fb4af94e&scoped=true"
import script from "./EBEquipment.vue?vue&type=script&lang=js"
export * from "./EBEquipment.vue?vue&type=script&lang=js"

import "./EBEquipment.vue?vue&type=style&index=0&id=fb4af94e&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4af94e"]])

export default __exports__